import React, { Component } from 'react';
import { Button, Card, Form, Col, Modal, ModalBody, ModalHeader, Row, Input, Label, FormGroup } from 'reactstrap';
import { deleteAPI, getAPI, postAPI, putAPI } from "../../../Base/API";
import { StyledCard, } from "../../../Base/Common/CommonUIComponents";
import { FormattedMessage, injectIntl } from 'react-intl';
import { handleNotification } from '../../../Base/Notification';
import countryList from "react-select-country-list";
import moment from 'moment';
import BlockUi from 'react-block-ui';
import { ErrorAlert } from '../../../Common/ErrorAlert';
import CustomSelect from '../../../Base/Common/CustomSelect';
import { DateRangePicker } from 'react-dates';
import { getMonths } from '../../../Base/Common/ReferenceDataFunctions';
import { CustomDateRangePicker } from '../../../Base/Common/CustomReactDates';
export class CityTaxModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            block: false,
            error: null,
            cityTaxConfig: this.props.selectedConfig || { cityTaxDetails: [{}] },
            focusedInput: null,
            tempDateFrom: this.props.selectedConfig?.dateFrom ? moment(this.props.selectedConfig.dateFrom) : null,
            tempDateTo: this.props.selectedConfig?.dateTo ? moment(this.props.selectedConfig.dateTo) : null
        }
    }

    componentDidMount() {
    }

    saveConfig = (e) => {
        e.preventDefault();
        this.setState({ block: true });

        const body = {
            ...this.state.cityTaxConfig,
            dateFrom: this.state.tempDateFrom ? this.state.tempDateFrom.format("YYYY-MM-DD") : null,
            dateTo: this.state.tempDateTo ? this.state.tempDateTo.format("YYYY-MM-DD") : null
        };


        postAPI(result => {
            const { data, error } = result;
            const errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ block: false, error: errorMessage });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState(({ block: false, error: errorMessage }));
                }
                else if (data.response) {
                    handleNotification(data, <FormattedMessage id="CityTaxConfig.ConfigSaved" />, <FormattedMessage id="General.Success" />);

                    this.props.updateTable(data.response[0]);
                    this.setState(({ block: false, error: errorMessage }));
                }
            }
            else {
                this.setState(({ block: false, error: errorMessage }));
            }
        }, '/api/hotel/v1/CreateCityTaxes', JSON.stringify({ request: body }));
    }

    handleSelect = (name, combo) => {
        this.setState(prevState => ({
            cityTaxConfig: {
                ...prevState.cityTaxConfig,
                [name]: combo && combo.value
            }
        }));
    }

    handleChange = (evt) => {
        const { name, value } = evt.target;

        this.setState(prevState => ({
            cityTaxConfig: {
                ...prevState.cityTaxConfig,
                [name]: value
            }
        }));
    }

    handleInt = (evt) => {
        const { name, value } = evt.target;

        const targetValue = value ? parseInt(value) : null;

        this.setState(prevState => ({
            cityTaxConfig: {
                ...prevState.cityTaxConfig,
                [name]: targetValue
            }
        }));
    }

    handleDates = (startDate, endDate) => {
        this.setState({
            tempDateFrom: startDate,
            tempDateTo: endDate
        });
    }

    addPeriod = () => {
        const { cityTaxConfig } = this.state;

        cityTaxConfig.cityTaxDetails.push({ });

        this.setState({ cityTaxConfig });
    }

    removePeriod = (index) => {
        const { cityTaxConfig } = this.state;

        cityTaxConfig.cityTaxDetails.splice(index, 1);

        this.setState({ cityTaxConfig });
    }

    handleChangePeriod = (name, value, index) => {
        const { cityTaxConfig } = this.state;
        const targetValue = value ? parseFloat(value) : null;

        cityTaxConfig.cityTaxDetails[index][name] = targetValue;

        this.setState({ cityTaxConfig });
    }

    render() {
        const { block, error, cityTaxConfig } = this.state;

        return (
            <Modal isOpen={this.props.modal} toggle={this.props.toggleModal}>
                <ModalBody className="p-0">
                    <BlockUi tag="div" blocking={block}>
                        <ErrorAlert error={error} />
                        <Form onSubmit={this.saveConfig}>
                            <Card className="shadow border-0" body>
                                <Row className="mb-3">
                                    <Col>
                                        <h5>{cityTaxConfig.id ? <FormattedMessage id="CityTaxConfig.EditConfig" /> : <FormattedMessage id="CityTaxConfig.CreateConfig" />} </h5>
                                    </Col>
                                    <Col className="text-right">
                                        <Button type="submit" className="btn btn-sm btn-host float-right">
                                            <i className="fas fa-save" />
                                        </Button>
                                    </Col>
                                </Row>

                                <FormGroup row>
                                    <Label sm={2}>
                                        <FormattedMessage id="CityTaxConfig.Country" />
                                    </Label>
                                    <Col sm={4}>
                                        <CustomSelect
                                            options={countryList().getData()}
                                            onChange={(combo) => this.handleSelect("country", combo)}
                                            placeholder={this.props.intl.formatMessage({ id: "CityTaxConfig.Country" })}
                                            value={countryList().getData().find(el => el.value === cityTaxConfig.country) || ''}
                                            isClearable
                                            required
                                        />
                                    </Col>
                                    <Label sm={2}>
                                        <FormattedMessage id="CityTaxConfig.MaxNights" />
                                    </Label>
                                    <Col sm={4}>
                                        <Input
                                            type="number"
                                            name="maxNights"
                                            required
                                            minLength={0}
                                            onChange={this.handleInt}
                                            value={cityTaxConfig.maxNights || ''}
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={2}>
                                        <FormattedMessage id="CityTaxConfig.City" />
                                    </Label>
                                    <Col sm={4}>
                                        <Input
                                            type="text"
                                            name="city"
                                            required
                                            maxLength={50}
                                            onChange={this.handleChange}
                                            value={cityTaxConfig.city || ''}
                                        />
                                    </Col>
                                    <Label sm={2}>
                                        <FormattedMessage id="CityTaxConfig.Validity" />
                                    </Label>
                                    <Col sm={4}>
                                        <CustomDateRangePicker
                                            startDate={this.state.tempDateFrom}
                                            startDateId="dateFrom"
                                            isOutsideRange={day => day <= moment().subtract(1, 'day')}
                                            endDate={this.state.tempDateTo}
                                            endDateId="dateTo"
                                            onDatesChange={(startDate, endDate) => this.handleDates(startDate, endDate)}
                                            focusedInput={this.state.focusedInput}
                                            onFocusChange={focusedInput => this.setState({ focusedInput })}
                                            small={true}
                                            numberOfMonths={global.isMobile  ? 1 : 2}
                                            showDefaultInputIcon={true}
                                            required
                                            showYearOptions={{ pastYears: false, futureYears: true }}
                                        />
                                    </Col>
                                </FormGroup>

                                <div>
                                    <div className="border-bottom mt-3 pb-2">
                                        <b> <FormattedMessage id="CityTaxConfig.ApplicableAgeRanges" /></b>
                                    </div>

                                    <FormGroup row className="text-muted my-2">
                                        <Col sm={6}> <FormattedMessage id="generic.Type" /> </Col>
                                        <Col> <FormattedMessage id="CityTaxConfig.MinAge" /> </Col>
                                        <Col> <FormattedMessage id="CityTaxConfig.MaxAge" /> </Col>
                                    </FormGroup>

                                    <FormGroup row className="align-items-center overbglight">
                                        <Col sm={6}>
                                            <FormattedMessage id="CityTaxConfig.BaseAgeRangeText" />
                                        </Col>
                                        <Col>
                                            <Input
                                                className="mx-2"
                                                style={{ width: '100px' }}
                                                type="number"
                                                name="minAge"
                                                required
                                                minLength={1}
                                                maxLength={150}
                                                onChange={this.handleInt}
                                                value={cityTaxConfig.minAge || ''}
                                                placeholder={this.props.intl.formatMessage({ id: "CityTaxConfig.FromRange" })}
                                            />
                                        </Col>
                                        <Col>
                                            <Input
                                                className="mx-2"
                                                style={{ width: '100px' }}
                                                type="number"
                                                name="maxAge"
                                                required
                                                minLength={cityTaxConfig.minAge || 1}
                                                maxLength={150}
                                                onChange={this.handleInt}
                                                value={cityTaxConfig.maxAge || ''}
                                                placeholder={this.props.intl.formatMessage({ id: "CityTaxConfig.ToRange" })}
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row className="align-items-center overbglight">
                                        <Col sm={6}>
                                            <FormattedMessage id="CityTaxConfig.LowerAgeRangeText" />
                                        </Col>
                                        <Col>
                                            <Input
                                                className="mx-2"
                                                style={{ width: '100px' }}
                                                type="number"
                                                name="descMinAge"
                                                min={1}
                                                max={cityTaxConfig.descMaxAge || cityTaxConfig.minAge || 1}
                                                onChange={this.handleInt}
                                                value={cityTaxConfig.descMinAge || ''}
                                                placeholder={this.props.intl.formatMessage({ id: "CityTaxConfig.FromRange" })}
                                            />
                                        </Col>
                                        <Col>
                                            <Input
                                                className="mx-2"
                                                style={{ width: '100px' }}
                                                type="number"
                                                name="descMaxAge"
                                                min={cityTaxConfig.descMinAge}
                                                max={cityTaxConfig.maxAge || 1}
                                                onChange={this.handleInt}
                                                value={cityTaxConfig.descMaxAge || ''}
                                                placeholder={this.props.intl.formatMessage({ id: "CityTaxConfig.ToRange" })}
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row className="align-items-center overbglight">
                                        <Col sm={6}>
                                            <FormattedMessage id="CityTaxConfig.UpperAgeRangeText" />
                                        </Col>
                                        <Col>
                                            <Input
                                                className="mx-2"
                                                style={{ width: '100px' }}
                                                type="number"
                                                name="upperDescMinAge"
                                                min={cityTaxConfig.maxAge}
                                                max={cityTaxConfig.upperDescMaxAge}
                                                onChange={this.handleInt}
                                                value={cityTaxConfig.upperDescMinAge || ''}
                                                placeholder={this.props.intl.formatMessage({ id: "CityTaxConfig.FromRange" })}
                                            />
                                        </Col>
                                        <Col>
                                            <Input
                                                className="mx-2"
                                                style={{ width: '100px' }}
                                                type="number"
                                                name="upperDescMaxAge"
                                                min={cityTaxConfig.upperDescMinAge}
                                                max={150}
                                                onChange={this.handleInt}
                                                value={cityTaxConfig.upperDescMaxAge || ''}
                                                placeholder={this.props.intl.formatMessage({ id: "CityTaxConfig.ToRange" })}
                                            />
                                        </Col>
                                    </FormGroup>
                                </div>

                                <div>
                                    <Row className="my-3 border-bottom pb-2 align-items-center">
                                        <Col>
                                            <b> <FormattedMessage id="CityTaxConfig.Periods" /></b>
                                        </Col>
                                        <Col className="text-right">
                                            <Button color="btn btn-sm btn-host " onClick={this.addPeriod}>
                                                <i className="fas fa-plus" />
                                            </Button>
                                        </Col>
                                    </Row>


                                    <FormGroup row className="text-muted my-2">
                                        <Col sm={3}> <FormattedMessage id="CityTaxConfig.From" /> </Col>
                                        <Col sm={3}> <FormattedMessage id="CityTaxConfig.To" /> </Col>
                                        <Col> <FormattedMessage id="CityTaxConfig.Amount" /> </Col>
                                        <Col> <FormattedMessage id="CityTaxConfig.Amount(Lower)" /> </Col>
                                        <Col> <FormattedMessage id="CityTaxConfig.Amount(Higher)" /> </Col>
                                        <Col className="col-1 text-center"> <FormattedMessage id="CityTaxConfig.Remove" /> </Col>
                                    </FormGroup>

                                    {cityTaxConfig.cityTaxDetails?.map((period, key) =>
                                        <Row key={key} className="overbglight py-2">
                                            <Col className="d-flex col-3">
                                                <Input
                                                    type="number"
                                                    name="fromDay"
                                                    value={period.fromDay || ''}
                                                    onChange={(e) => this.handleChangePeriod("fromDay", e.target?.value, key)}
                                                    placeholder={this.props.intl.formatMessage({ id: "CityTaxConfig.Day" })}
                                                    style={{ width: '60px' }}
                                                    required
                                                    min={1}
                                                    max={period.fromMonth ? moment(`2024-${period.fromMonth}`, "YYYY-M").daysInMonth() : 31}
                                                />

                                                <div className="ml-2" style={{ width: '150px' }}>
                                                    <CustomSelect
                                                        options={getMonths(this.props.intl)}
                                                        onChange={(combo) => this.handleChangePeriod("fromMonth", combo?.value, key)}
                                                        value={getMonths(this.props.intl).find(el => el.value === period.fromMonth) || ''}
                                                        placeholder={this.props.intl.formatMessage({ id: "CityTaxConfig.Month" })}
                                                        required
                                                    />
                                                </div>
                                            </Col>
                                            <Col className="d-flex col-3">
                                                <Input
                                                    type="number"
                                                    name="toDay"
                                                    value={period.toDay || ''}
                                                    onChange={(e) => this.handleChangePeriod("toDay", e.target?.value, key)}
                                                    placeholder={this.props.intl.formatMessage({ id: "CityTaxConfig.Day" })}
                                                    style={{ width: '60px' }}
                                                    required
                                                    min={1}
                                                    max={period.fromMonth ? moment(`2024-${period.toMonth}`, "YYYY-M").daysInMonth() : 31}
                                                />

                                                <div className="ml-2" style={{ width: '150px' }}>
                                                    <CustomSelect
                                                        style={{ width: '100px' }}
                                                        options={getMonths(this.props.intl)}
                                                        onChange={(combo) => this.handleChangePeriod("toMonth", combo?.value, key)}
                                                        value={getMonths(this.props.intl).find(el => el.value === period.toMonth) || ''}
                                                        placeholder={this.props.intl.formatMessage({ id: "CityTaxConfig.Month" })}
                                                        required
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <Input
                                                    type="number"
                                                    min={0.01} max={999999999}
                                                    step={0.01}
                                                    required
                                                    name="amount"
                                                    value={period.amount || ''}
                                                    onChange={(e) => this.handleChangePeriod("amount", e.target?.value, key)}
                                                    placeholder={this.props.intl.formatMessage({ id: "CityTaxConfig.Amount" })}
                                                />
                                            </Col>
                                            <Col>
                                                <Input
                                                    type="number"
                                                    min={0} max={999999999}
                                                    step={0.01}
                                                    required
                                                    name="descAmountLowerRange"
                                                    value={period.descAmountLowerRange === null || period.descAmountLowerRange === undefined ? '' : period.descAmountLowerRange}
                                                    onChange={(e) => this.handleChangePeriod("descAmountLowerRange", e.target?.value, key)}
                                                    placeholder={this.props.intl.formatMessage({ id: "CityTaxConfig.Amount(Lower)" })}
                                                    disabled={!cityTaxConfig.descMinAge && !cityTaxConfig.descMaxAge}
                                                />
                                            </Col>
                                            <Col>
                                                <Input
                                                    type="number"
                                                    min={1} max={999999999}
                                                    step={0.01}
                                                    required
                                                    name="descAmountUpperRange"
                                                    value={period.descAmountUpperRange || ''}
                                                    onChange={(e) => this.handleChangePeriod("descAmountUpperRange", e.target?.value, key)}
                                                    placeholder={this.props.intl.formatMessage({ id: "CityTaxConfig.Amount(Higher)" })}
                                                    disabled={!cityTaxConfig.upperDescMinAge && !cityTaxConfig.upperDescMaxAge}
                                                />
                                            </Col>
                                            <Col className="col-1 text-center">
                                                <Button color="btn btn-sm btn-host " onClick={() => this.removePeriod(key)}>
                                                    <i className="fas fa-trash-alt" />
                                                </Button>
                                            </Col>
                                        </Row>
                                    )}
                                </div>
                            </Card>
                        </Form>
                    </BlockUi>
                </ModalBody>
            </Modal>
        );
    }
}

export default injectIntl(CityTaxModal)